import React from "react";
import { Typography } from "antd";
import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";

function Footer(): React.ReactNode {
  const { t } = useTranslation();
  return (
    <Typography.Text
      strong
      style={{ textAlign: "center", display: "block", width: "100%" }}
    >
      {t("common.haveAnAccount")} &thinsp;
      <NavLink to="/sign-in">{t("signIn.text")}</NavLink>
    </Typography.Text>
  );
}

export default Footer;
